"use client"

import { useReportWebVitals } from "next/web-vitals"

import { trackGlobalMetric } from "./app-insights-global"

/**
 * Core Web Vitals → App Insights customMetrics (M21): web_vitals.LCP / CLS /
 * INP / TTFB / FCP. Field data from real users, queryable next to the backend
 * request timings in the same resource. No-ops when telemetry is disabled.
 * Renders nothing.
 */
export function WebVitalsReporter() {
  useReportWebVitals((metric) => {
    trackGlobalMetric(`web_vitals.${metric.name}`, metric.value)
  })

  return null
}
